const $ = require('jquery');

export function Slider(selector) {
    'use strict';
    var self = this;
    this.selector = selector;
    this.options = {
        arrows: false,
        dots: false,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        autoplay: true
    };

    this.init = function(){
        $(self.selector).on('init', function(event, slick){
            document.getElementById('slider-caption').classList.toggle('caption--show');
            self.captionFromImage(slick,0);
        });
        
        self.beforeChange();
        self.afterChange();
        self.attachSlider();
    }   

    this.beforeChange = function(){
        $(self.selector).on('beforeChange', function(event, slick, currentSlide){
            document.getElementById('slider-caption').classList.toggle('caption--show');
        });
    }

    this.afterChange = function(){
        $(self.selector).on('afterChange', function(event, slick, currentSlide){
            self.captionFromImage(slick,currentSlide);
            document.getElementById('slider-caption').classList.toggle('caption--show');
        });
    }

    this.attachSlider = function(){
        $(self.selector).slick(self.options);
    }

    this.captionFromImage = function (slick,currentSlide){
        let image = slick.$slides[currentSlide].querySelector('.slider--image');
        self.captionText(image.dataset.captionTop,image.dataset.captionBottom);
    }

    this.captionText = function captionText(captionTop, captionBottom){
        if(captionTop){
            document.getElementById('slider-caption-top').innerHTML = captionTop;
        }

        if( captionBottom){
            document.getElementById('slider-caption-bottom').innerHTML = captionBottom;
        }
    }
}